import { StepResult } from '../../interfaces/responsedata.ts/trackresults';
import { Suggestion } from './../../interfaces/ai';
import { Component, EventEmitter, Input, Output, SimpleChanges,  ElementRef, ViewChild, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { InstructionsComponent } from '../instructions/instructions.component';
import { AiService } from '../../service/ai.service';
import { SnackService } from '../../service/snack.service';
import { ReportService } from '../../service/report.service';
import { TrackService } from '../../service/track.service';
import { TrackResult } from '../../interfaces/responsedata.ts/trackresults';

@Component({
  selector: 'app-user-insight-mapping',
  standalone: false,
  templateUrl: './user-insight-mapping.component.html',
  styleUrl: './user-insight-mapping.component.scss'
})
export class UserInsightMappingComponent {
  // Injections
  @ViewChild('chatContent') chatContent!: ElementRef;
  trackService = inject(TrackService);
  fb = inject(FormBuilder);
  dialog = inject(MatDialog);
  aiService = inject(AiService);
  report = inject(ReportService);
  snack = inject(SnackService);

  // Inputs
  @Input() stepId: any;
  @Input() streamId: any;
  @Input() step: any;
  @Input() roundId: any;
  @Input() thisStepCount: number = 0;
  @Input() totalStepCount: number = 0;
  @Input() runClosingPrompt: boolean = false;
  @Input() initialReady: boolean = false;

  // Outputs
  @Output() nextStreamStepDisabledStatus: EventEmitter<boolean> = new EventEmitter(true);
  @Output() closingPromptReady: EventEmitter<{ "input": string, "type": string, "extendedData"?: any } | undefined> = new EventEmitter(undefined);

  // Variables
  nextBtnDisabledStatus: boolean = true;
  loading: boolean = false;
  maxSteps: number = 4;
  activeStep: number = 1;


  // Objects
  personaSelectionControl: any = this.fb.control('');
  persona: any = {
    name: "Lena Leaf",
    image: ""
  };
  questionHeadlines: { main: string, sub: string }[] = [
    { main: "What does the user hear?", sub: "What do others say about the challenge or topic?" },
    { main: "What does the user see?", sub: "What's happening in the environment or around them?" },
    { main: "What does the user feel?", sub: "What emotions or concerns come up in response?" },
    { main: "What frustrates the user most?", sub: "What obstacles or blockers are they facing?" }
  ];

  communicationHistory: any[] = [];
  currentQuestion: string = `<QUESTION>
  ${this.questionHeadlines[0].main} ${this.questionHeadlines[0].sub}`;
  suggestionStorage: any[] = [[], [], [], []];
  currentSuggestions: { id: string, text: string }[] = []
  streamResults: any = [];
  storage: any;

  async ngOnChanges(changes: SimpleChanges) {
    if (changes["runClosingPrompt"] && changes["runClosingPrompt"].currentValue) {
      if (changes["runClosingPrompt"].currentValue === true) {
        this.startCLosingPrompt();
      }
    }
    if (changes["initialReady"] && changes["initialReady"].currentValue === true) {
      // Load Mian Persona for Inteview Data
      let pers = await this.findDataById("Ci6Ju_grd");
      if (pers) {
        this.persona = pers.result;
        if (typeof this.persona == "string") {
          this.persona = JSON.parse(this.persona);
        }
      }

      let c = await this.trackService.loadComHistory(this.stepId, this.roundId);
      if (c) {
        if (!c.suggestionStorage) return;

        this.suggestionStorage = c.suggestionStorage;
        this.activeStep = this.suggestionStorage.length;
        for (let i = 0; i < this.suggestionStorage.length; i++) {
          if (this.suggestionStorage[i].length == 0) { this.activeStep = i; break; }
        }

        if (this.activeStep === 3) {
          this.nextStreamStepDisabledStatus.emit(false);
        }
        this.nextStep();
      } else {
        this.nextStreamStepDisabledStatus.emit(true);
        this.activeStep = 0;
        this.nextStep();
      }
    }
  }
  addSuggestion(suggestion: Suggestion) {
    let arrayNumber = this.activeStep - 1
    this.suggestionStorage[arrayNumber].push(suggestion);
    this.currentSuggestions = this.currentSuggestions.filter((s: Suggestion) => s != suggestion)
  }
  async findDataById(id: string): Promise<StepResult | undefined> {
    let results = await this.trackService.trackResults.getValue();
    let streamResults = await results.find((r: TrackResult) => r.streamId === this.streamId);
    let pers: StepResult | undefined = await streamResults?.stepResults.find((s: any) => s.stepId == id);
    return pers;
  }
  async resetData() {
    let confirmResult = await confirm('Do you really want to reset your Data? All Files and Memory-Data will be deleted.')
    if (!confirmResult) {
      return;
    }
    let files = await this.trackService.trackFiles.getValue();
    for await (let file of files) {
      if (file.roundId == this.roundId && file.stepId == this.stepId) {
        await this.trackService.deleteFileFromTrackResult(this.roundId, file.id, file.fileName)
      }
    }
    this.activeStep = 0;

    this.suggestionStorage = [[], [], [], []];
    this.report.saveReport(this.roundId, 'Reset & Start Again')
    this.nextStreamStepDisabledStatus.emit(true);
    this.communicationHistory = [];
    this.nextStep();
  }
  async restartAgain() {
    let confirmResult = await confirm('Do you really want to reset your Data? All Files and Memory-Data will be deleted.')
    if (!confirmResult) {
      return;
    }

    this.resetData();

  }
  async startCLosingPrompt() {
    if (!this.streamId || !this.stepId) {
      this.snack.error({ error: { msg: { "headline": "Frontend Error", "text": "Stream ID or Step ID is not provided" } } });
      return;
    }
    let promptType = 'CLOSING_STEP_PROMPT';
    let userInput = `<MAIN PERSONA>
    ${JSON.stringify(this.persona)}
    `;
    let counter = 0;
    for await (let h of this.questionHeadlines) {
      userInput += `
      <QUESTION>${h.main} ${h.sub}
      <ANSWERS>`;

      for await (const data of this.suggestionStorage[counter]) {
        userInput += `\n${data.text}`;
      }

      counter++;
    }

    this.closingPromptReady.emit({ "input": userInput, "type": promptType, "extendedData": this.persona });

  }
  async collectInitStorage() {
    let counter = 0;
    while (this.streamResults?.length == 0 && counter < 10) {
      await new Promise(resolve => setTimeout(resolve, 100));
      counter++;
    }

    let basicIdea: any = this.findDataById("MMUT2vQla");

    if (!basicIdea) {
      return
    }

    let basicIdeaObject = `
    Name: ${basicIdea?.result?.name}
    Tagline: ${basicIdea?.result?.tagline}
    Key Features: ${basicIdea?.result?.key_features}
    Target Group: ${basicIdea?.result?.target_group}
    Value Proposition: ${basicIdea?.result?.value_proposition}`;

    let personaObject = `
    Name: ${this.persona?.name}
    Demographics: ${this.persona?.demographics}
    Sinus Milieuse: ${this.persona?.sinus_milieuse}
    Goals: ${this.persona?.goals}
    Values: ${this.persona?.values}
    Lifestyle: ${this.persona?.lifestyle}
    Pain Points: ${this.persona?.pain_points}
    Potential benefits from ElderChat: ${this.persona?.potential_benefits_from_ElderChat}`;

    this.communicationHistory.push({
      type: '<target user>',
      content: personaObject
    });
    this.communicationHistory.push({
      type: '<idea card>',
      content: basicIdeaObject
    });



    return `<target user>${personaObject}

    <idea card>${basicIdeaObject}

    ${this.currentQuestion}`

  }
  async loadSuggestionsForQuestion(): Promise<void> {
    let promptType = 'STEP_PROMPT';
    let initStorage = await this.collectInitStorage();

    this.loading = true;
    let result = await this.aiService.getAiResponse(this.streamId, this.stepId, JSON.stringify(initStorage), promptType, 0, this.roundId);
    this.loading = false;

    let counter = 0;
    while ((result === false || result.promptResult.length === 0) && counter < 3) {
      counter++;
      this.loading = true;
      console.log("Error in AI response ==> RESTART: ", result.promptResult);
      result = await this.aiService.getAiResponse(this.streamId, this.stepId, JSON.stringify(initStorage), promptType, 0, this.roundId);
      this.loading = false;
    }

    this.currentSuggestions = result?.promptResult || [];

    this.scrollToBottom();
  }
  updateSuggestiontext(suggestion: Suggestion) {
    let arrayNumber = this.activeStep - 1;
    this.suggestionStorage[arrayNumber] = this.suggestionStorage[arrayNumber].map((s: Suggestion) => s.id === suggestion.id ? { ...s, text: suggestion.text } : s);
    this.nextStreamStepDisabledStatus.emit(true);
  }
  deleteSuggestion(suggestion: Suggestion) {
    this.suggestionStorage[this.activeStep - 1] = this.suggestionStorage[this.activeStep - 1].filter((s: Suggestion) => s.id !== suggestion.id);
    this.checkSaveResultValidation();
    this.nextStreamStepDisabledStatus.emit(true);
  }

  async nextStep(fromInit: boolean = false) {
    this.currentSuggestions = []
    this.activeStep += 1;
    this.checkSaveResultValidation();

    if (fromInit === false) {
      this.trackService.saveComHistory(this.stepId, this.roundId, { "suggestionStorage": this.suggestionStorage, "persona": { "name": this.persona.name, "occupation": this.persona.demographics.occupation } });
    }

    if (this.activeStep > this.maxSteps) {
      this.nextStreamStepDisabledStatus.emit(false);
      return;
    }

    let arrayNumber = this.activeStep - 1;

    this.currentQuestion = `<QUESTION>
  ${this.questionHeadlines[arrayNumber].main} ${this.questionHeadlines[arrayNumber].sub}`;

    if (this.suggestionStorage[this.activeStep - 1].length === 0) {
      await this.loadSuggestionsForQuestion();
    }
    this.scrollToBottom();

  }
  async checkSaveResultValidation() {
    let validated: boolean = true;
    for await (const sugs of this.suggestionStorage) {
      if (sugs.length == 0) validated = false
    }
  }
  async setStep(step: number) {
    if (step > this.activeStep) return;
    this.activeStep = step;
    this.currentSuggestions = [];
    let arrayNumber = this.activeStep - 1;
    this.currentQuestion = `<QUESTION>
  ${this.questionHeadlines[arrayNumber].main} ${this.questionHeadlines[arrayNumber].sub}`;
    this.checkSaveResultValidation();
  }

  async openInstructions() {
    let dia = await this.dialog.open(InstructionsComponent, {
      data: { for: 'problemShadowing' },
      width: '500px'
    });

    dia.afterClosed().subscribe((result) => { })
  }
  scrollToBottom(): void {
    try {
      if (this.activeStep == 1) return;
      setTimeout(() => {
        const el = document.getElementById("insight-control-" + (this.activeStep - 1));
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } catch (err) {
      // Fehlerbehandlung, falls nötig
    }
  }
}
